import {
  RecoilRoot
} from 'recoil';

import './App.css';
import { MainContent } from './components/MainContent';


function App() {

  return (
    <RecoilRoot>
      <MainContent />
    </RecoilRoot>
  );
}

export default App;

/* document.addEventListener("DOMContentLoaded", function (event) {
  let myID = document.getElementById("menu_fix");

  let StickMenu = function () {
    var y = window.scrollY;
    if (y >= 400) {
      myID.classList.add('stick')
    } else {
      myID.classList.remove('stick')
    }
  };

  window.addEventListener("scroll", StickMenu);
});
 */
